import { jsxs as p, jsx as o } from "@emotion/react/jsx-runtime";
import { ErrorBoundary as u } from "react-error-boundary";
import { DefaultFallbackContainer as d } from "./ErrorBoundary.styled.js";
import { Button as f } from "../Button/index.js";
import { Text as k } from "../Text/index.js";
const E = "Oups something went wrong !", F = "Refetch", T = ({
  dataTrackId: t,
  errorText: a = E,
  actionText: r = F,
  resetErrorBoundary: n
}) => /* @__PURE__ */ p(d, { children: [
  /* @__PURE__ */ o(k, { variant: "heading6", children: a }),
  /* @__PURE__ */ o(f, { variant: "primary", appearance: "text", dataTrackId: `${t}__reftech`, onClick: n, children: r })
] }), B = ({
  dataTrackId: t,
  FallbackComponent: a,
  onReset: r,
  onError: n,
  errorText: e,
  actionText: l,
  children: c
}) => {
  const m = {
    dataTrackId: t,
    errorText: e,
    actionText: l,
    resetErrorBoundary: r
  }, s = a ?? T;
  return /* @__PURE__ */ o(u, { FallbackComponent: (i) => /* @__PURE__ */ o(s, { ...m, ...i }), onReset: r, onError: n, children: c });
};
export {
  T as DefaultFallbackComponent,
  B as ErrorBoundary
};
